import Text from "components/Text";
import { useEffect, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { withTranslation } from "react-i18next";
import styles from "../staff.module.scss";
const defaultedValue = ["a"];
const AccordionWrapper = ({
  children,
  preSelected: preExpanded = defaultedValue,
  heading,
  reOpen,
  setReOpen,
  renderChildOnly,
  parentClass = "",
  changeExpandedClass,
}) => {
  const [expanded, setExpanded] = useState(preExpanded || defaultedValue);
  useEffect(() => {
    if (reOpen && !expanded.length) {
      setExpanded(defaultedValue);
      setReOpen();
    }
  }, [reOpen]);
  if (renderChildOnly) {
    return children;
  }
  return (
    <div
      className={
        `${styles["form-padding-fix"]} ${
          parentClass || "green-main-color-form"
        } ` +
        " " +
        styles["border-radius-form"] +
        " " +
        (changeExpandedClass
          ? changeExpandedClass
          : expanded.length
          ? styles["mb-40"]
          : "")
      }
    >
      <Accordion
        className="filter-accordion"
        allowZeroExpanded
        preExpanded={expanded}
        allowMultipleExpanded
        onChange={() => {
          setExpanded(expanded.length ? [] : defaultedValue);
        }}
      >
        <AccordionItem uuid="a" dangerouslySetExpanded={expanded.length > 0}>
          <AccordionItemHeading>
            <AccordionItemButton>
              <Text size="16px" weight="600" color="#587E85">
                {heading}
              </Text>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className={`${styles["accordian_margin-fix"]}`}>{children}</AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};
export default withTranslation()(AccordionWrapper);
